import { render, staticRenderFns } from "./PhoneCartegory.vue?vue&type=template&id=352f0c77&scoped=true&"
import script from "./PhoneCartegory.vue?vue&type=script&lang=js&"
export * from "./PhoneCartegory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f0c77",
  null
  
)

export default component.exports